import type { JSX } from 'react';
import { isDefined, isUndefined } from 'dg-web-shared/lib/MaybeV2.ts';
import {
    SlideInHeaderButtonsContainer,
    SlideInHeaderIcon,
    SlideInHeaderTexts,
    StandardFirstLevelHeader,
} from '../../ui/slidein/Slidein.tsx';
import * as Icons24 from 'dg-web-shared/ui/icons/Icons24.tsx';
import * as ClearanceEditState from '../state/ClearanceEditState.ts';
import { Translation } from '../../common/i18n/Text.ts';
import { deselectClearance } from '../actions/ClearanceDetailActions.ts';
import { useStore } from 'dg-web-shared/lib/Flux.tsx';
import { useLanguage } from 'dg-web-shared/lib/Localization.tsx';
import { isActive } from '../../clearance-permit-list/state/LicensePlateBadgeClearancesState.ts';
import * as ClearanceViewHeaderTexts from '../i18n/ClearanceViewHeaderTexts.tsx';
import { Color } from '../../ui/Colors.ts';
import {
    ButtonDropdown,
    ButtonDropdownItem,
} from '../../ui/slidein/ButtonDropdown.tsx';

export interface Texts {
    active: Translation;
    expired: Translation;
    clearance: Translation;
    terminateTooltip: Translation;
    editLabel: Translation;
}

function getIcon(
    clearance: ClearanceEditState.Server.State['data'],
): JSX.Element {
    if (isUndefined(clearance)) {
        return Icons24.clearanceState.active;
    } else if (isActive(clearance)) {
        return Icons24.clearanceState.active;
    } else {
        return Icons24.clearanceState.inactive;
    }
}

export function ClearanceViewHeader() {
    const { storeState, update } = useStore(store => ({
        selectedClearance: ClearanceEditState.Server.get(store),
    }));
    const { language } = useLanguage();

    const texts = ClearanceViewHeaderTexts.texts[language];
    const clearance = storeState.selectedClearance.data;
    const status =
        isDefined(clearance) && isActive(clearance)
            ? texts.active()
            : texts.expired();

    return (
        <StandardFirstLevelHeader onClose={() => update(deselectClearance)}>
            <SlideInHeaderIcon
                icon={getIcon(clearance)}
                color={Color.darkblue}
            />
            <SlideInHeaderTexts title={status} hasLeftIcon={true} />
            <SlideInHeaderButtonsContainer>
                <ButtonDropdown label={texts.editLabel()}>
                    <ButtonDropdownItem
                        label={texts.terminateTooltip()}
                        onClick={() =>
                            update(store =>
                                ClearanceEditState.Delete.stateWrite(store, {
                                    deletePressed: true,
                                }),
                            )
                        }
                    />
                </ButtonDropdown>
            </SlideInHeaderButtonsContainer>
        </StandardFirstLevelHeader>
    );
}
